import { z } from "zod";
import { SONIC_GENRES, SONIC_ERAS, SONIC_TIMBRES, SONIC_VIBES } from "./vocabulary.js";
// Canonical shape of an artist's sonic identity (spec §3.6). All axes optional;
// `{}` is a valid "no traits" value — the zero-regression baseline.
export const sonicTraitsSchema = z.object({
    genres: z.array(z.enum(SONIC_GENRES)).max(3).optional(),
    era: z.enum(SONIC_ERAS).optional(),
    energy: z.number().int().min(1).max(5).optional(),
    timbre: z.array(z.enum(SONIC_TIMBRES)).max(3).optional(),
    vibe: z.array(z.enum(SONIC_VIBES)).max(3).optional(),
});
//# sourceMappingURL=schema.js.map